import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { Container, Card, Table, Button, Spinner, Alert, Row, Col, Form } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle, faSearch, faFilter, faBroom } from '@fortawesome/free-solid-svg-icons';
import moment from 'moment';
import { getClearObject } from 'src/utils/utils';
import { USER_ACTIONS } from 'src/utils/constants';
import { isNotEmptyArray, isNotEmptyObject } from 'src/services/validationService';
import { seeMore, seeLess } from 'src/utils/label'
import { clearAuditsUsersList } from 'src/redux/audit/auditActions'
import { getAuditsUsersListData, getAuditsUsersListIsFetching, getAuditsUsersListMetadata } from 'src/redux/audit/auditReducer';
import { tryGetAuditsUsersList } from 'src/redux/audit/auditActionCreator';
import { dateToStringFormatedToShowUSA } from 'src/utils/utils';
import ActionIcon from 'src/components/general/ActionIcon';
import UserAuditDetailModal from 'src/components/pages/Audits/UserAuditDetailModal';
import AppLoading from 'src/components/common/AppLoading';
import RCPagination from '../../common/RCPagination';

const AuditsUsersPage = () => {
    const dispatch = useDispatch();
    const { handleSubmit, register, reset, getValues } = useForm();

    let auditData = useSelector(state => getAuditsUsersListData(state))?.records || [];
        // ?.sort((a, b) => a.created_at < b.created_at ? 1 : -1);
    const hasAuditData = isNotEmptyArray(auditData);
    const metadata = useSelector(state => getAuditsUsersListMetadata(state));
    const auditDataIsFetching = useSelector(state => getAuditsUsersListIsFetching(state));
    const todayDate = dateToStringFormatedToShowUSA(new Date());
    const defaultParams = {
        size: 10,
    }

    const [totalCount, setTotalCount] = useState(0);
    const [pageNumber, setPageNumber] = useState(0);
    const onPageChange = (pNumber) => {
        onClickLoadPage(pNumber)
    }

    //Audit detail modal
    const [dataModal, setDataModal] = useState();
    const [show, setShow] = useState(false);
    const handleShow = () => setShow(true);
    const handleClose = () => setShow(false);

    const onClickAuditDetailModal = (auditData) => {
        setDataModal(auditData);
        handleShow(true);
    };

    const loadAllData = () => {
        fetchList(defaultParams);
    }

    useEffect(loadAllData, []);


    //Documentar metodo!
    const buildParams = (data) =>{
        const {StartDate, EndDate, page} = data;
        // data.dateFrom = data.dateTo = null;
        const filterText = getClearObject(data);
        filterText.email &&= filterText.email.trim();

        return {
            StartDate,
            EndDate,
            page,
            ...(isNotEmptyObject(filterText) && {filter: filterText})
        }
    }

    const onSubmitForm = (data) => {
        fetchList(buildParams(data));
    }

    const onClickLoadPage = (page) => {
        let formData = getValues();
        formData = {
            ...formData,
            ...defaultParams,
            page
        }
        fetchList(buildParams(formData));
    };

    const clearFilters = () => {
        reset();
        loadAllData();
    };
    
    const fetchList = (params) => {
        dispatch(clearAuditsUsersList());
        dispatch(tryGetAuditsUsersList(params));
    }
    
    useEffect(() => {
        setTotalCount(metadata?.totalCount)
        setPageNumber(metadata?.page - 1)
    }, [metadata])
    
    return <>
            <Container fluid>
                <Card className='my-3'>
                    <Card.Header className='h6'>
                        Auditorías de Usuarios
                    </Card.Header>
                    <Card.Body>
                        <Form onSubmit={handleSubmit(onSubmitForm)} autoComplete='off'>
                            <Table striped hover size='sm' >
                                <thead>
                                    <tr>
                                        <th className='text-center align-middle' width='20%'>Fecha y Hora</th>
                                        <th className='text-center align-middle' width="30%">Nombre de usuario</th>
                                        <th className='text-center align-middle' width="20%">Email del usuario</th>
                                        <th className='text-center align-middle' width='20%'>Acción</th>
                                        <th className='text-center align-middle' width='10%'>Detalle</th>
                                    </tr>
                                    <tr className='secondary'>
                                        <th className='text-center align-middle d-flex my-0 py-1'>
                                            <Form.Control
                                                type='date'
                                                size="sm"
                                                name='StartDate'
                                                ref={register}
                                                max={todayDate}
                                                className='text-center mr-1'
                                                title='Fecha desde'
                                            />
                                            <Form.Control
                                                type='date'
                                                size="sm"
                                                name='EndDate'
                                                ref={register}
                                                max={todayDate}
                                                className='text-center'
                                                title='Fecha hasta'
                                            />
                                        </th>
                                        <th className='text-center align-middle'>
                                            {/* <Form.Control
                                                type='text'
                                                size="sm"
                                                className='text-left'
                                                name='name'
                                                ref={register}
                                                placeholder="Filtrar nombre de usuario"
                                            /> */}
                                        </th>
                                        <th className='text-center align-middle'>
                                            <Form.Control
                                                type='text'
                                                size="sm"
                                                className='text-left'
                                                name='email'
                                                ref={register}
                                                placeholder="Filtrar email del usuario"
                                            />
                                        </th>
                                        <th className='text-center align-middle'>
                                            <Form.Control
                                                as="select"
                                                size="sm"
                                                ref={register}
                                                name='actionId'
                                                className="text-black-color"
                                            >
                                                <option className='text-black-color' value={''}>
                                                    Filtrar acción
                                                </option>
                                                {USER_ACTIONS.map( action => 
                                                    <option key={action.id} value={action.id}>
                                                        {action.name}
                                                    </option>
                                                )}
                                            </Form.Control>
                                        </th>
                                        <th className='text-center align-middle'>
											<div className='d-flex justify-content-around'>
												<ActionIcon
													size="sm"
													id="search-button"
													className="btn-primary search-button text-white-color mx-2 py-1"
													toolTipText="Filtrar"
													icon={faFilter}
													type='submit'
													onSubmit={onSubmitForm}
												/>
												<ActionIcon
													size="sm"
													id="clean-filter"
													className="btn-primary clean-filter text-white-color mx-2 py-1"
													toolTipText="Limpiar filtros"
													icon={faBroom}
													type='reset'
													onClick={()=> clearFilters()}
												/>
											</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody className='text-black-color'>
                                    {
                                        hasAuditData
                                            ?
                                                auditData?.map((item, i) => 
                                                    <tr key={i}>
                                                        <td className='text-center align-middle tipeTableFormat tbTipo'>
                                                            {moment(item?.dateCreated).format('DD/MM/YYYY HH:mm')}
                                                        </td>
                                                        <td className='text-center align-middle actionTableFormat tbAction'>
                                                            {item?.usuario?.name}
                                                        </td>
                                                        <td className='text-center align-middle actionTableFormat tbAction'>
                                                            {item?.usuario?.email}
                                                        </td>
                                                        <td className='text-center align-middle '>
                                                            {item?.actionName}
                                                        </td>
                                                        <td className='text-center align-middle p-0 m-0 table-responsive'>
                                                            <ActionIcon size='lg' toolTipText='Detalle de la auditoría' icon={faSearch} onClick={() => onClickAuditDetailModal(item)} />
                                                        </td>
                                                    </tr>
                                                )
                                            
                                            :
                                            <tr>
                                                <td colSpan='13' className='text-center'>
                                                    {
                                                        !auditDataIsFetching &&
                                                            <Alert variant='info' className='mb-0'>
                                                                <FontAwesomeIcon icon={faExclamationTriangle} className='text-black-color mr-3' />
                                                                No hay registros
                                                            </Alert>
                                                    }
                                                </td>
                                            </tr>
                                    }
                                </tbody>
                            </Table>
                            <RCPagination
                                activePage={pageNumber + 1}
                                itemsCountPerPage={defaultParams.size}
                                totalItemsCount={totalCount}
                                totalItems={totalCount}
                                thePage={pageNumber + 1}
                                onChange={onPageChange}
                                innerClass="justify-content-center"
                            /> 
                        </Form>
                    </Card.Body>
                </Card>
            </Container>
            <UserAuditDetailModal
                show = {show}
                handleClose = {handleClose}
                dataModal = { dataModal }
            />
            <AppLoading isLoading={auditDataIsFetching} />
    </>
}
export default AuditsUsersPage; 